import * as React from 'react';
import classnames from 'classnames';
import '@swc/helpers';
import '@grandvisionhq/state';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import '../../../../../../types/product.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import { ProductDetailPrice } from '../../../PriceSection/components/ProductDetailPrice/ProductDetailPrice.js';
import '@grandvisionhq/lib-visuals';
import '../../../../../../slots/context.js';

const PricingBadge = ({ className , id , purchaseTypePrice  })=>/*#__PURE__*/ React.createElement("div", {
        id: id,
        className: classnames('pricing-badge', className)
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        className: "pricing-badge__price",
        customSize: "small",
        centAmount: purchaseTypePrice.isCentAmount,
        originalPrice: purchaseTypePrice.originalPrice,
        discountedPrice: purchaseTypePrice.discountedPrice,
        currency: purchaseTypePrice.currency
    }))
;

export { PricingBadge };
//# sourceMappingURL=PricingBadge.js.map
